var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"type-well-lap"},_vm._l((_vm.state.lapTimeMsStrList),function(lap){return _c('div',{key:lap.key,staticClass:"lap"},[_vm._v(" "+_vm._s(lap.timeMs)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }